// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1Nzqs","notes":"Notes_notes__1GZOY"};